import {INotificationConfiguration} from "../class/notification.defs";
import {IgenomicsAction} from "@ispm/core/interfaces/genomics-action.interface";
import {NotificationActionTypes} from "@ispm/dashboard/notification/store/notification.actions";

export interface INotificationState {
  description: INotificationConfiguration;
}

const notificationInitState: INotificationState = {
  description: null
};

export function notificationReducer(state: INotificationState = notificationInitState, action: IgenomicsAction): INotificationState {
  let newState;
  switch (action.type) {
    case NotificationActionTypes.SetNotification:
      newState = Object.assign({}, state, {description: action.payload});
      return newState;
    case NotificationActionTypes.ClearNotification:
      newState = {...state};
      if (newState.description) {
        delete newState.description;
      }
      return newState;
    default:
      return state;
  }
}
